import React, { Component } from "react";
import {
  Map,
  TileLayer,
  FeatureGroup,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import { EditControl } from "react-leaflet-draw";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-shadow.png",
});

class DrawTools extends Component {
  state = {
    count: 0,
  };

  _editableFG = null;


  _onEdited = (e) => {
    // Handle editing of shapes
  };

  _onCreated = (e) => {
    let type = e.layerType;
    let layer = e.layer;
    console.log("onsave in thedrawtool")

    this.setState((prevState) => ({ count: prevState.count + 1 }));

    if (type === "marker") {
      // Do marker specific actions
      layer.bindTooltip("point" + this.state.count);
      layer.bindPopup("point 2");
    } else {
      layer.bindTooltip("point" + this.state.count);
    }

    if (layer.setStyle) {
      // Set styles for the drawn items
      layer.setStyle({
        fillColor: "#3388ff", // Fill color
        color: "#3388ff",     // Stroke color
        opacity: 0.7,         // Opacity
      
      });

      // Set a higher z-index to ensure the items are above other layers
      layer.options.zIndex = 1000;
    }

    // Save GeoJSON data
    this.saveGeoJSON();
  };

  saveGeoJSON = () => {
    if (!this._editableFG || !this.props.onSave) {
      return;
    }

    const geojsonData = this._editableFG.leafletElement.toGeoJSON();
    this.props.onSave(geojsonData);
  };

  _onDeleted = (e) => {
    this.props.onSave(null);

  };

  _onMounted = (drawControl) => {
    // Handle mount event
  };

  _onEditStart = (e) => {
    // Handle edit start event
  };

  _onEditStop = (e) => {
    // Handle edit stop event
  };

  _onDeleteStart = (e) => {
    // Handle delete start event
  };

  _onDeleteStop = (e) => {
    // Handle delete stop event
  };

  _onFeatureGroupReady = (reactFGref) => {
    // Store the reference for future access
    this._editableFG = reactFGref;
  };

  _onChange = () => {
    // Handle change event
  };

  render() {
    console.log("onsave",this.props.onSave)
    return (
      <div>
        
        

        <FeatureGroup
          ref={(reactFGref) => {
            this._onFeatureGroupReady(reactFGref);
          }}
        >
        
        
            <EditControl
              position="bottomright"
              onEdited={this._onEdited}
              onCreated={this._onCreated}
              onDeleted={this._onDeleted}
              onMounted={this._onMounted}
              onEditStart={this._onEditStart}
              onEditStop={this._onEditStop}
              onDeleteStart={this._onDeleteStart}
              onDeleteStop={this._onDeleteStop}
              draw={{
                rectangle: true,
              }}
            />
      
      
        </FeatureGroup>
      </div>
    );
  }
}

export default DrawTools;
